import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

// Create a context
export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState('/');
  const location = useLocation();
  const isActive = (path) => currentPath === path;

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    // Update current path
    setCurrentPath(location.pathname);

    // Scroll to top when path changes (ignore hash links)
    if (!location.hash) {
      window.scrollTo({
        top: 0,
      });
    }
  }, [location]);

  const value = {
    menuOpen,
    setMenuOpen,
    toggleMenu,
    currentPath,
    isActive,
  };

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
};

GlobalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
